import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermFaqCategory from '@/components/TermFaqCategory';

const FaqTransferPaymentPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">よくあるご質問</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <TermFaqCategory />
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">振込・支払い関連</div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">売上金の振込申請はどうすればいい？</div>
              <div className="self-stretch pl-5 flex flex-col justify-start items-center">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  ウェブ版・アプリ版ともにマイページから申請が可能です。<br />
                  詳細は以下のページをご確認ください。
                </div>
                <Link to={`/terms/request_withdrawal${location.search}`} className="w-full justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                  売上金の振込申請手順
                </Link>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">振込申請の口座情報を間違えた。</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  申請された情報に不備があり振込を実行できなかった場合、売上金はアカウントへ戻ります。<br />
                  このように振込が失敗した場合に限り事務局からご連絡いたしますので、お知らせを受け取りましたら口座情報をご確認のうえ、改めて振込申請をお願いいたします。<br />
                  なお、振込申請後の振込先変更やキャンセルは承っておりません。<br />
                  振込に関して問題がある場合は、登録されているメールアドレスと電話番号を明記のうえ、事務局までお問い合わせください。
                </div>
                <div className="flex flex-col justify-start items-start">
                  <div className="w-full justify-center text-black text-base font-bold leading-7">申請中に振込申請期限を迎えた場合</div>
                  <div className="w-full justify-center text-black text-base font-normal leading-7">
                    振込が失敗した場合、<span className="font-bold">売上金は失効いたします。</span><br />
                    期限の超過によって失効した売上金は、いかなる理由があっても復元はできません。<br />
                    振込スケジュールや反映日を事前にご確認のうえ、必ず期限内に振込（入金）まで完了するようご注意ください。
                  </div>
                  <div className="w-full justify-center text-black text-base font-normal leading-7">詳細は以下のページをご確認ください。</div>
                  <Link to={`/terms/sale_transfer${location.search}`} className="w-full justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                    売上金・振込について
                  </Link>
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">取引キャンセル時の返金はある？</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  取引がキャンセルとなった場合、<span className="font-bold">お支払い済みの代金は返金されます。</span><br />
                  クレジットカードでお支払いの場合は、与信枠が自動的にキャンセルされます。<br />
                  実際の返金タイミングや明細反映の時期については、ご利用のカード会社へお問い合わせください。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">領収書や適格請求書（インボイス）がほしい。</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  DONDONでは、<span className="font-bold">領収書および適格請求書（インボイス）の発行は行っておりません。</span><br />
                  ※キャンセル料のお支払いに関しても同様に、発行はいたしかねます。<br />
                  領収書はクレジットカードのご利用明細をご利用ください。<br />
                  適格請求書（インボイス）は取引完了後の取引詳細画面をスクリーンショットし、印刷したものをご利用ください。
                </div>
              </div>
            </div>
          </div>
          
          <TermFaqCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default FaqTransferPaymentPage;